import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["extent", "min", "max", "width", "height", "format", "operation"];
import { bandsOperation } from "../utils/bandOperation/bands";
import { isNumberArray } from "../utils/util";
export default function rasterRgb(data, cfg) {
  var extent = cfg.extent,
      min = cfg.min,
      max = cfg.max,
      width = cfg.width,
      height = cfg.height,
      format = cfg.format,
      operation = cfg.operation,
      rest = _objectWithoutProperties(cfg, _excluded);

  var bandData;

  if (format === undefined || isNumberArray(data)) {
    // 兼容写法 - 用户直接传入解析完的波段数据
    bandData = Array.from(data);
  } else {
    // 用户传入为解析的栅格数据 - arraybuffer
    // 将数据统一为 IRasterFileData[]
    var imageDataList = Array.isArray(data) ? data : [data];
    bandData = bandsOperation(imageDataList, format, operation);
  }

  var resultData = {
    _id: 1,
    dataArray: [_objectSpread(_objectSpread({
      _id: 1,
      data: bandData,
      width: width,
      height: height
    }, rest), {}, {
      min: min,
      max: max,
      coordinates: [[extent[0], extent[1]], [extent[2], extent[3]]]
    })]
  };
  return resultData;
}